import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Cheng Lin </span>
            from <span className="purple"> Hong Kong.</span>
            <br /> I am a full-stack developer with over 8 years of experience in software development across
            various industries. 
            <br />
            Engaged in Full Stack projects, with a proven ability to ensure high
            standards of code quality, security, and performance. Expertise in microservices architecture,
            cloud infrastructure, and automation. I have extensive knowledge of front-end JavaScript and
            browser APIs as well as significant experience with popular frameworks and libraries like
            React and Redux.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Basketball
            </li>
            <li className="about-activity">
              <ImPointRight /> Reading books
            </li>
            <li className="about-activity">
              <ImPointRight /> Listening to Music
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">Cheng Lin</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
